/**
 * This is the maximum delay that the setTimeout accepts
 */
const MAX_TIMEOUT = 2147483647

export const sleep = (ms: number) =>
  new Promise<void>(resolve => {
    if (ms > MAX_TIMEOUT) {
      setTimeout(resolve, MAX_TIMEOUT)
    } else {
      setTimeout(resolve, ms)
    }
  })
